"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryAddElementCommand = arbitraryAddElementCommand;
exports.arbitraryRemoveElementCommand = arbitraryRemoveElementCommand;
exports.arbitrarySetDocumentDescriptionCommand = arbitrarySetDocumentDescriptionCommand;
exports.arbitrarySetDocumentNameCommand = arbitrarySetDocumentNameCommand;
exports.arbitraryAddPcbNodesCommand = arbitraryAddPcbNodesCommand;
exports.arbitraryRemovePcbNodesCommand = arbitraryRemovePcbNodesCommand;
exports.arbitraryUpdatePcbNodesCommand = arbitraryUpdatePcbNodesCommand;
exports.arbitraryAddPcbRuleSetCommand = arbitraryAddPcbRuleSetCommand;
exports.arbitraryRemovePcbRuleSetCommand = arbitraryRemovePcbRuleSetCommand;
exports.arbitraryUpdatePcbRuleSetsCommand = arbitraryUpdatePcbRuleSetsCommand;
exports.arbitrarySetElementPropertyCommand = arbitrarySetElementPropertyCommand;
exports.arbitraryConnectPinsCommand = arbitraryConnectPinsCommand;
exports.arbitraryDisconnectPinsCommand = arbitraryDisconnectPinsCommand;
exports.arbitraryCommand = arbitraryCommand;
exports.arbitraryCommands = arbitraryCommands;
const tslib_1 = require("tslib");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
const command_1 = require("../../src/document/command");
const net_1 = require("./net");
const pcb_1 = require("./pcb");
function arbitraryAddElementCommand(constraints = {}) {
    return fast_check_1.default.record({
        type: fast_check_1.default.constant(command_1.CommandType.addElementCommand),
        elementUid: fast_check_1.default.uuid(),
        partDescriptor: fast_check_1.default.record({
            partUid: constraints.partUid ? fast_check_1.default.constant(constraints.partUid) : fast_check_1.default.uuid(),
            partVersion: constraints.partVersionUid ? fast_check_1.default.constant(constraints.partVersionUid) : fast_check_1.default.uuid(),
        }),
    });
}
function arbitraryRemoveElementCommand(constraints = {}) {
    return fast_check_1.default.record({
        type: fast_check_1.default.constant(command_1.CommandType.removeElementCommand),
        elementUid: constraints.elementUid ? fast_check_1.default.constant(constraints.elementUid) : fast_check_1.default.uuid(),
    });
}
function arbitrarySetDocumentDescriptionCommand(constraints = {}) {
    return fast_check_1.default.record({
        type: fast_check_1.default.constant(command_1.CommandType.setDocumentDescriptionCommand),
        description: constraints.description ? fast_check_1.default.constant(constraints.description) : fast_check_1.default.lorem(),
    });
}
function arbitrarySetDocumentNameCommand(constraints = {}) {
    return fast_check_1.default.record({
        type: fast_check_1.default.constant(command_1.CommandType.setDocumentNameCommand),
        name: constraints.name ? fast_check_1.default.constant(constraints.name) : fast_check_1.default.string(),
    });
}
function arbitraryAddPcbNodesCommand(constraints = {}) {
    return fast_check_1.default.record({
        type: fast_check_1.default.constant(command_1.CommandType.addPcbNodesCommand),
        nodes: constraints.nodes ? fast_check_1.default.constant(constraints.nodes) : (0, pcb_1.arbitraryUniquePcbNodes)({ minLength: 1 }),
        skipSort: fast_check_1.default.boolean(),
    });
}
function arbitraryRemovePcbNodesCommand(constraints = {}) {
    return fast_check_1.default.record({
        type: fast_check_1.default.constant(command_1.CommandType.removePcbNodesCommand),
        nodeUids: constraints.nodeUids ? fast_check_1.default.constant(constraints.nodeUids) : fast_check_1.default.uniqueArray(fast_check_1.default.string()),
    });
}
function arbitraryUpdatePcbNodesCommand(constraints = {}) {
    return fast_check_1.default.record({
        type: fast_check_1.default.constant(command_1.CommandType.updatePcbNodesCommand),
        nodes: constraints.nodes ? fast_check_1.default.constant(constraints.nodes) : (0, pcb_1.arbitraryUniquePcbNodes)({ minLength: 1 }),
    });
}
function arbitraryAddPcbRuleSetCommand(constraints = {}) {
    return fast_check_1.default.record({
        type: fast_check_1.default.constant(command_1.CommandType.addPcbRuleSetsCommand),
        ruleSets: constraints.ruleSets ? fast_check_1.default.constant(constraints.ruleSets) : fast_check_1.default.array((0, pcb_1.arbitraryPcbRuleSet)()),
    });
}
function arbitraryRemovePcbRuleSetCommand(constraints = {}) {
    return fast_check_1.default.record({
        type: fast_check_1.default.constant(command_1.CommandType.removePcbRuleSetsCommand),
        ruleSetUids: constraints.ruleSetUids ? fast_check_1.default.constant(constraints.ruleSetUids) : fast_check_1.default.uniqueArray(fast_check_1.default.string()),
    });
}
function arbitraryUpdatePcbRuleSetsCommand(constraints = {}) {
    return fast_check_1.default.record({
        type: fast_check_1.default.constant(command_1.CommandType.updatePcbRuleSetsCommand),
        ruleSets: constraints.ruleSets ? fast_check_1.default.constant(constraints.ruleSets) : fast_check_1.default.array((0, pcb_1.arbitraryPcbRuleSet)()),
    });
}
function arbitrarySetElementPropertyCommand(constraints = {}) {
    return fast_check_1.default.record({
        type: fast_check_1.default.constant(command_1.CommandType.setElementPropertyCommand),
        propertyUid: constraints.propertyUid ? fast_check_1.default.constant(constraints.propertyUid) : fast_check_1.default.string(),
        elementUid: constraints.elementUid ? fast_check_1.default.constant(constraints.elementUid) : fast_check_1.default.string(),
        propertyName: constraints.propertyName ? fast_check_1.default.constant(constraints.propertyName) : fast_check_1.default.string(),
        rawPropertyValue: constraints.rawPropertyValue ? fast_check_1.default.constant(constraints.rawPropertyValue) : fast_check_1.default.string(),
    });
}
function arbitraryConnectPinsCommand(constraints = {}) {
    return fast_check_1.default.record({
        type: fast_check_1.default.constant(command_1.CommandType.connectPinsCommand),
        source: constraints.source ? fast_check_1.default.constant(constraints.source) : (0, net_1.arbitraryPin)(),
        target: constraints.target ? fast_check_1.default.constant(constraints.target) : (0, net_1.arbitraryPin)(),
    });
}
function arbitraryDisconnectPinsCommand(constraints = {}) {
    return fast_check_1.default.record({
        type: fast_check_1.default.constant(command_1.CommandType.disconnectPinsCommand),
        source: constraints.source ? fast_check_1.default.constant(constraints.source) : (0, net_1.arbitraryPin)(),
        target: constraints.target ? fast_check_1.default.constant(constraints.target) : (0, net_1.arbitraryPin)(),
    });
}
/**
 * Generate an arbitrary command.
 */
function arbitraryCommand() {
    return fast_check_1.default.oneof(arbitraryAddElementCommand(), arbitrarySetDocumentDescriptionCommand(), arbitrarySetDocumentNameCommand(), arbitraryAddPcbNodesCommand(), arbitraryRemovePcbNodesCommand(), arbitraryUpdatePcbNodesCommand(), arbitraryAddPcbRuleSetCommand(), arbitraryUpdatePcbRuleSetsCommand(), arbitraryRemovePcbRuleSetCommand(), arbitrarySetElementPropertyCommand(), arbitraryConnectPinsCommand());
}
/**
 * Generate an arbitrary number of commands.
 */
function arbitraryCommands(constraints = {}) {
    return fast_check_1.default.array(arbitraryCommand(), constraints);
}
//# sourceMappingURL=command.js.map